<div class="layout">
  <div *ngIf="header"
       class="section-header no-border">
    <h1>{{ header }}</h1>
  </div>
  <div>
    <ng-content></ng-content>
  </div>
</div>
